import _asyncToGenerator from "F:/bio_link_pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "clientProjectDialog"
};
var _hoisted_2 = {
  class: "dialog-footer"
};
import { ref, watch, nextTick } from "vue";
import _ from "lodash";
import { set_client_project } from "@/api/apis";
import moment from "moment";
import { ElMessage } from "element-plus";
export default {
  __name: 'clientProjectDialog',
  props: ["isShow", "id"],
  emits: ["onClose"],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var props = __props;
    var emit = __emit;
    var dialogVisible = ref(false);
    var projects = ref(null);
    var handleProjectDataUpdate = val => {
      projects.value = val;
    };
    var handleClose = () => {
      emit("onClose", "close");
    };
    var projectItemRef = ref(null);
    var handle_submit = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(function* () {
        var _projects$value;
        if (!((_projects$value = projects.value) !== null && _projects$value !== void 0 && _projects$value.length)) {
          ElMessage({
            type: "warning",
            message: "请添加项目信息"
          });
          return;
        }
        var projectValid = true;
        if (projectItemRef.value && projectItemRef.value.validateTable) {
          projectValid = yield projectItemRef.value.validateTable();
        }

        // 如果项目信息校验不通过，则不提交
        if (!projectValid) {
          ElMessage({
            type: "warning",
            message: "请完善项目信息"
          });
          return;
        }
        var obj = {
          projects: [...projects.value],
          client_id: props.id
        };
        set_client_project(obj, "post").then(res => {
          if (res.code == 200) {
            ElMessage({
              type: "success",
              message: "保存成功"
            });
            emit("onClose", "add");
          }
        });
      });
      return function handle_submit() {
        return _ref2.apply(this, arguments);
      };
    }();
    watch(() => {
      return props.isShow;
    }, newData => {
      dialogVisible.value = newData;
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      var _component_add_project_item = _resolveComponent("add-project-item");
      var _component_el_button = _resolveComponent("el-button");
      var _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => dialogVisible.value = $event),
        title: "新增客户项目",
        width: "1000px",
        "destroy-on-close": true,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "show-close": false,
        onClose: handleClose
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
          onClick: handleClose
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode("取消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handle_submit
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode(" 确定 ")])),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_add_project_item, {
          data: projects.value,
          onOnUpdate: handleProjectDataUpdate,
          ref_key: "projectItemRef",
          ref: projectItemRef
        }, null, 8, ["data"])])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
};